{
  "oiv.app.mobiliar": "la Mobiliare",
  "oiv.app.protekta": "Protekta",
  "oiv.app.title": "Condizioni generali",
  "oiv.button.close": "Chiudere",
  "oiv.error.avbNotFound": "CGA non trovate",
  "oiv.error.eId.notFound": "Il riferimento al contenuto (eID) richiesto non è stato trovato",
  "oiv.error.forbidden": "Non si dispone dell’autorizzazione per accedere a questa risorsa",
  "oiv.error.general": "Spiacenti, qualcosa è andato storto",
  "oiv.error.indexInfoNotFound": "Indice di ricerca non trovato",
  "oiv.footer.company.name": "Protekta Assicurazione di protezione giuridica SA",
  "oiv.footer.contactAndFeedback": "Servizi e contatto",
  "oiv.footer.contactAndFeedback.link": "https://www.mobiliare.ch/contatto",
  "oiv.footer.dataProtection": "Protezione dei dati",
  "oiv.footer.dataprotection.link": "https://www.mobiliare.ch/protezione-dei-dati",
  "oiv.footer.imprint": "Impressum",
  "oiv.footer.imprint.link": "https://www.mobiliare.ch/impressum",
  "oiv.footer.instruction": "Avvertenze per l’uso",
  "oiv.footer.instruction.p1": "Si prega di considerare che la rappresentazione delle Condizioni generali digitali può essere diversa su terminali e browser differenti.",
  "oiv.footer.instruction.p2": "Raccomandiamo di scaricare la versione PDF delle Condizioni generali nella rispettiva lingua e di salvarla sul proprio dispositivo per assicurarsi di avere a disposizione la versione giuridicamente vincolante.",
  "oiv.footer.instruction.p3": "Se a causa di errori o equivoci dovuti alla rappresentazione HTML dovessero emergere domande o dubbi, consigliamo di fare riferimento alla versione PDF giuridicamente vincolante delle Condizioni generali.",
  "oiv.footer.legalInfo": "Informazioni legali",
  "oiv.footer.legalInfo.link": "https://www.mobiliare.ch/aspetti-giuridici",
  "oiv.footer.protekta.contactAndFeedback": "Contatto",
  "oiv.homepage.button.question": "((not in use)) Domande",
  "oiv.homepage.head.title": "Informazioni per la clientela e Condizioni generali",
  "oiv.homepage.info.paragraph.b2c": "Domande sull’assicurazione? Le Condizioni generali di assicurazione permettono di visualizzare le informazioni principali.",
  "oiv.homepage.info.paragraph.b2e": "Domande sull’assicurazione? Le Condizioni generali di assicurazione permettono di visualizzare le informazioni principali.",
  "oiv.homepage.notFeelLikeWriting": "((not in use)) Nessuna voglia di scrivere?",
  "oiv.homepage.p.goToTopic": "((not in use)) Nessun problema! È possibile accedere direttamente a un tema.",
  "oiv.homepage.placeholder.textarea": "((not in use)) Esempio di domanda che trasmette l’idea...",
  "oiv.homepage.title.content": "Sommario",
  "oiv.indexSearch.error.text": "Riprovare tra qualche minuto.",
  "oiv.indexSearch.error.title": "Spiacenti, qualcosa è andato storto",
  "oiv.indexSearch.results": "Risultati per",
  "oiv.indexSearch.title": "Ricerca",
  "oiv.message.copy": "Copiato!",
  "oiv.message.urlCopy": "URL copiato!",
  "oiv.navigation.splitButton.menu": "Sommario",
  "oiv.navigation.splitButton.search": "Ricerca",
  "oiv.navigation.title.contact": "Contatto",
  "oiv.navigation.title.contact.link": "https://www.mobiliare.ch/contatto",
  "oiv.navigation.title.downloadPDF": "Scaricare PDF",
  "oiv.navigation.title.furtherTopics": "Altri temi",
  "oiv.navigation.title.goToCustomerPortal": "Al portale clienti",
  "oiv.navigation.title.goToCustomerPortal.link": "https://www.mobiliare.ch/login",
  "oiv.navigation.title.goToLegalAdviser": "Guida giuridica della Mobiliare",
  "oiv.navigation.title.requestAdvice": "Richiedere aiuto",
  "oiv.navigation.title.visitProductPage": "Pagina prodotti",
  "oiv.no-permission.title": "Non dispone dell’accesso a questa pagina.\nSe ne ha bisogno, richieda il ruolo \"OIV Approval\".",
  "oiv.not-available.title": "La data di pubblicazione per questo contenuto non è stata ancora raggiunta.",
  "oiv.not-found.avb-overview": "Panoramica: Condizioni generali (www.mobiliare.ch)",
  "oiv.not-found.avb-overview-rednet": "E-biblioteca: Condizioni generali di assicurazione",
  "oiv.not-found.avb-overview-rednet.link": "https://services.marketing.mobiliere.ch/fr/downloads/e-bibliotheque?list.filter=%7B%22mobi:mawi.productgroup%22:%5B%22root.avb.%22%5D,%22censhare:asset.language%22:%5B%22it%22%5D%7D&s.text=&m.fset=true",
  "oiv.not-found.avb-overview.link": "https://mobiliare.ch/cga",
  "oiv.not-found.contact": "Contatto",
  "oiv.not-found.contact.link": "https://www.mobiliare.ch/contatto",
  "oiv.not-found.continue": "Avanti",
  "oiv.not-found.customer-portal": "Portale clienti «La mia Mobiliare»",
  "oiv.not-found.customer-portal.link": "https://www.mobiliare.ch/login",
  "oiv.not-found.heading.text": "Non ci è stato possibile trovare la pagina richiesta. Si prega di provare una delle seguenti opzioni per raggiungere il proprio obiettivo.",
  "oiv.not-found.heading.title": "Purtroppo brancoliamo nel buio.",
  "oiv.not-found.more-possibilities": "Altre possibilità di accesso",
  "oiv.not-found.protekta.avb-overview": "Panoramica: Condizioni generali (www.protekta.ch)",
  "oiv.placeholder.search": "Che cosa si sta cercando?",
  "oiv.search.error.message": "Pronto a cercare? Inserire il termine di ricerca.",
  "oiv.title.collapseAll": "Comprimi tutto",
  "oiv.title.expandAll": "Espandi tutto"
}